import Swal from "sweetalert2";
<template>
    <div>

        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 class="h2">Gestion des PV</h1>
        </div>

        <div class="mb-3 background-alt parent">
            <div class="col-lg-12 mt-3 mb-3">

                <div class="row">
                    <span class="centerFilter">Filtrer : </span>
                    <button class="btn btn-info btnFilter" v-for="(filtre, index) in arrayFilter" v-show="filtre !== ''"
                            @click="deleteFilter(index)">{{ filtre.label }} <i class="fas fa-times"/></button>
                </div>

                <div class="row">
                    <div class="col-lg-4 pt-2 pb-2">
                        <v-select class="select background-alt" :options="officers" v-model="officer"/>
                    </div>
                    <div class="col-lg-4 pt-2 pb-2">
                        <v-select class="select background-alt" :options="vehicles" v-model="vehicle"/>
                    </div>
                    <div class="col-lg-4 pt-2 pb-2">
                        <v-select class="select background-alt" :options="devices" v-model="device"/>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-4  pt-2 pb-2">
                        <date-picker ref="datePickerComponent"/>
                    </div>
                    <div class="col-lg-4 pt-2 pb-2">
                        <v-select class="select background-alt" :options="lines" v-model="line"/>
                    </div>
                    <div class="col-lg-4 pt-2 pb-2">
                        <v-select class="select background-alt" :options="reasons" v-model="reason"/>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-4 pt-2 pb-2">
                        <v-select class="select background-alt" :options="tigreExportStatuses"
                                  v-model="tigreExportStatus"/>
                    </div>
                    <div class="col-lg-4 row ml-auto pl-0">
                        <div class="col-lg-6 pl-0 pt-2 pb-2">
                            <button class="btn btn-custom w-100" @click="filter" title="Rechercher">Rechercher</button>
                        </div>
                        <div class="col-lg-6 pl-0 pt-2 pb-2">
                            <button class="btn btn-custom w-100" @click="initFilter"
                                    title="Réinitialiser la recherche">
                                Réinitialiser
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-3 row">

            <div class="col-lg-6">
                <div class="col-lg-12 background-alt">
                    <vue-element-loading :active="isActiveChart" spinner="spinner" class="customLoader"
                                         color="#a3285e"/>

                    <line-chart :chart-data="dataChart"
                                chartId="bar-chart-1"
                                :options="{responsive: true, maintainAspectRatio: false,beginAtZero: true}"/>
                </div>
            </div>

            <div class="col-lg-6">
                <open-street-map class="col-lg-12 background-alt sizeMap"
                                 :array-markers="arrayMarkers"
                                 :coordinate-map="coordinateMap"
                />
            </div>

        </div>

        <div class="mb-3 background-alt">

            <div class="row">
                <div class="col-lg-4 row ml-auto pl-0">
                    <span v-if="idSession">
                        <a class="btn btn-warning text-white" @click="deleteSession()">Pour la session : {{ idSession }} <i
                                class="far fa-times-circle"/></a>
                    </span>
                    <div class="col-lg-6 pl-0 pt-2 pb-2">
                        <button class="btn btn-custom w-100" @click="exportToTigre(fineIdsToExport)" title="Soumettre">
                            Soumettre
                        </button>
                        <vue-element-loading :active="exportInProgress" color="#a3285e" spinner="spinner"
                                             is-full-screen/>
                    </div>

                    <div class="col-lg-6 pl-0 pt-2 pb-2">
                        <button
                            class="btn btn-custom w-100"
                            title="Exporter les amendes"
                            @click="showCsvDownloadModal = true"
                        >
                            Exporter
                        </button>
                    </div>

                </div>
            </div>
            <div class="row">
                <div class="col">
                    <button class="btn btn-link" @click="selectAll()" title="Tout sélectionner">Tous</button>
                    -
                    <button class="btn btn-link" @click="deselectAll()" title="Déselectionner">Aucun</button>
                </div>
            </div>

            <div class="table-responsive">

                <vuetable ref="vuetable"
                          api-url="/api/fines/table"
                          :fields="fields"
                          :append-params="moreParams"
                          :http-options="{ headers: { 'Authorization': 'Bearer ' + api_token }}"
                          pagination-path=""
                          @vuetable:pagination-data="onPaginationData"
                          class="table"
                          no-data-template="">

                    <div slot="checkbox-slot1" slot-scope="props">
                        <input type="checkbox" :value="props.rowData.id" v-model="fineIdsToExport">
                    </div>

                    <div slot="exported" slot-scope="props" class="text-center align-middle p-2">
                        <template
                                v-if="getGlobalExportStatus(props.rowData.exported,props.rowData.exportedImage) === 'Non soumis'">
                            <i class="fas fa-paper-plane fa-lg text-info" title="Non soumis"/>
                        </template>
                        <template
                                v-if="getGlobalExportStatus(props.rowData.exported,props.rowData.exportedImage) === 'Ignoré'">
                            <i class="fas fa-ban fa-lg text-secondary" title="Ignoré"/>
                        </template>
                        <template
                                v-if="getGlobalExportStatus(props.rowData.exported,props.rowData.exportedImage) === 'En erreur'">
                            <i class="fas fa-times fa-lg text-danger" title="En erreur"/>
                        </template>
                        <template
                                v-if="getGlobalExportStatus(props.rowData.exported,props.rowData.exportedImage) === 'Soumis'">
                            <i class="fas fa-check fa-lg text-success" title="Soumis"/>
                        </template>
                    </div>

                    <div slot="gender-slot" slot-scope="props" class="action-container">
                        <button class="btn-custom btn" @click="openDetailsModal(props.rowData.id)">
                            <i class="fas fa-search" title="Afficher les détails"/>
                        </button>
                        <button class="btn-custom btn" @click="openExportModal(props.rowData.id)">
                            <i class="fas fa-share" title="Afficher les détails de la soumission à Tigre"/>
                        </button>
                        <button class="btn-custom btn" @click="openHtmlModal(props.rowData.fine_id)">
                            <i class="fas fa-file" title="Afficher la vue HTML du PV"/>
                        </button>
                    </div>

                </vuetable>

            </div>

            <div class="row col-lg-12 pr-0">
                <div class="mr-auto">
                    <vuetable-pagination-info ref="paginationInfo"
                                              class="alert alert-info tablePagination"
                                              info-template="Affichage de {from} à {to} sur {total} procès verbaux"
                                              no-data-template="Aucun PV"/>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                                         @vuetable-pagination:change-page="onChangePage"
                                         :css="css.pagination"/>
                </div>
            </div>
        </div>

        <fine-details-modal
                v-if="fineId"
                :showModal="showDetailsModal"
                :openModal="openDetailsModal"
                :closeModal="closeDetailsModal"
                :fineId="fineId"
        />

        <fine-export-modal
                v-if="fineId"
                :showModal="showExportModal"
                :openModal="openExportModal"
                :closeModal="closeExportModal"
                :fineId="fineId"
        />

        <fine-export-result-modal
                v-if="showExportResultModal"
                :showModal="showExportResultModal"
                :closeModal="closeExportResultModal"
                :exportResult="exportResult"
                :fineExportsInError="fineExportsInError"
        />

        <fine-html-modal
                v-if="showHtmlModal"
                :showModal="showHtmlModal"
                :closeModal="closeHtmlModal"
                :fineCode="fineCode"
        />

        <csv-download-modal
            :show-modal="showCsvDownloadModal"
            :download-url="'/download/fines' + this.urlParam"
            file-name-prefix="IER-PV-"
            @closeModal="showCsvDownloadModal = false"
        />

        <infringement-search-result-modal/>

    </div>

</template>

<script>

    import OpenStreetMap from './layout/OpenStreetMap';
    import L from 'leaflet';
    import Vue from 'vue';
    import Vuetable from 'vuetable-2';
    import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
    import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo';
    import vSelect from 'vue-select';
    import LineChart from './layout/LineChart';
    import DatePicker from './layout/DateRangePicker';
    import Modal from './layout/Modal';
    import moment from 'moment';
    import axios from 'axios';
    import VueElementLoading from 'vue-element-loading';
    import FineDetailsModal from "./layout/FineDetailsModal";
    import FineExportModal from "./layout/FineExportModal";
    import FineExportResultModal from "./layout/FineExportResultModal";
    import FineHtmlModal from "./layout/FineHtmlModal";
    import InfringementSearchResultModal from "./layout/InfringementSearchResultModal";
    import CsvDownloadModal from "./layout/CsvDownloadModal";

    export default {
        components: {
            vSelect,
            LineChart,
            Vuetable,
            VuetablePagination,
            VuetablePaginationInfo,
            DatePicker,
            Modal,
            OpenStreetMap,
            VueElementLoading,
            FineDetailsModal,
            FineExportModal,
            FineExportResultModal,
            FineHtmlModal,
            InfringementSearchResultModal,
            CsvDownloadModal
        },
        data() {
            return {
                map: {},
                coordinateMap: {},
                dataChart: {},
                arrayMarkers: [],
                moreParams: {},

                showDetailsModal: false,
                showExportModal: false,
                showExportResultModal: false,
                showHtmlModal: false,

                showCsvDownloadModal: false,

                dateDefine: '',
                urlParam: '',
                idSession: '',
                isActiveChart: true,

                lines: [],
                vehicles: [],
                officers: [],
                reasons: [],
                devices: [],
                tigreExportStatuses: [],

                line: '',
                officer: '',
                vehicle: '',
                reason: '',
                device: '',
                dateStart: '',
                dateEnd: '',
                tigreExportStatus: '',

                arrayFilter: {
                    line: '',
                    officer: '',
                    vehicle: '',
                    reason: '',
                    device: '',
                    date: '',
                    tigreExportStatus: ''
                },

                fineId: null,
                fineCode: null,

                exportInProgress: false,
                fineIdsToExport: [],
                exportResult: '',
                fineExportsInError: [],

                fields: [
                    {
                        name: 'checkbox-slot1',
                        title: '',
                    },
                    {
                        name: 'fine_id',
                        title: 'Numéro'
                    },
                    {
                        name: 'date',
                        title: 'Date'
                    },
                    {
                        name: 'person',
                        title: 'Personne verbalisée'
                    },
                    {
                        name: 'rate',
                        title: 'Prix',
                        formatter: (value) => value + '€'
                    },
                    {
                        name: 'reason',
                        title: 'Motif'
                    },
                    {
                        name: 'document',
                        title: 'Justificatif'
                    },
                    {
                        name: 'vehicle',
                        title: 'Véhicule'
                    },
                    {
                        name: 'exported',
                        title: 'Export Tigre'
                    },
                    {
                        name: 'gender-slot',
                        title: '',
                    },
                ],

                css: {
                    pagination: {
                        activeClass: 'btn-custom',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: '',
                            prev: '',
                            next: '',
                            last: '',
                        }
                    }
                },
            }
        },
        created() {
            axios.get('/api/parameters/value?key=web.dashboard.fine.period')
                .then(result => {
                    this.dateDefine = result.data;
                    this.dateStart = moment().subtract(this.dateDefine - 1, 'd').format('YYYY-MM-DD');
                    this.dateEnd = moment().format('YYYY-MM-DD');
                    this.initFilter();
                });

            this.$on('show-modal', (e) => {
                this.openModal(e.data.id)
            });

            if (this.hasSessionId) {
                this.idSession = this.$route.params.id;
            }
        },
        mounted() {
            axios.get('/api/parameters/value?key=web.dashboard.control.coordinate')
                .then(result => {
                    let coord = JSON.parse(result.data);
                    this.coordinateMap = new L.latLng([coord.lat, coord.lng])
                });
        },
        watch: {
            line: function () {
                if (this.line.id) {
                    this.arrayFilter.line = this.line;
                }
            },
            officer: function () {
                if (this.officer.id) {
                    this.arrayFilter.officer = this.officer;
                }

            },
            vehicle: function () {
                if (this.vehicle.id) {
                    this.arrayFilter.vehicle = this.vehicle;
                }
            },
            reason: function () {
                if (this.reason.id) {
                    this.arrayFilter.reason = this.reason;
                }
            },
            device: function () {
                if (this.device.id) {
                    this.arrayFilter.device = this.device;
                }
            },
            tigreExportStatus: function () {
                if (this.tigreExportStatus.id) {
                    this.arrayFilter.tigreExportStatus = this.tigreExportStatus;
                }
            }
        },
        computed: {
            hasSessionId() {
                return !!this.$route.params.id;
            },
            api_token() {
                return api_token;
            }
        },
        methods: {
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData);
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },

            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },

            getLine() {
                this.lines = [];
                this.line = {id: '', label: 'Ligne'};
                this.arrayFilter.line = '';
                axios.get('/api/lines')
                    .then(result => {
                        _.forEach(result.data, value => {
                            this.lines.push(
                                {
                                    id: value.id,
                                    label: value.label,
                                }
                            );
                        });
                    })
            },

            getVehicle() {
                this.vehicles = [];
                this.vehicle = {id: '', label: 'Véhicule'};
                this.arrayFilter.vehicle = '';
                axios.get('/api/vehicles')
                    .then(result => {
                        _.forEach(result.data, value => {
                            this.vehicles.push(
                                {
                                    id: value.id,
                                    label: value.label,
                                }
                            );
                        });
                    })
            },

            getOfficer() {
                this.officers = [];
                this.officer = {id: '', label: 'Agent'};
                this.arrayFilter.officer = '';
                axios.get('/api/officers')
                    .then(result => {
                        _.forEach(result.data, value => {
                            let name = value.registration_number + " - " + value.last_name + " " + value.first_name;
                            value.deleted_at !== null ? name = name + " (supprimé)" : name;
                            this.officers.push(
                                {
                                    id: value.id,
                                    label: name,
                                }
                            );
                        });
                    })
            },

            getReason() {
                this.reasons = [];
                this.reason = {id: '', label: 'Motif'};
                this.arrayFilter.reason = '';
                axios.get('/api/repositories/noticeReason')
                    .then(result => {
                        let arrayReason = _.orderBy(result.data.data, 'label', 'asc');
                        _.forEach(arrayReason, value => {
                            this.reasons.push(
                                {
                                    id: value.id,
                                    label: value.label,
                                }
                            );
                        })
                    })
            },

            getDevice() {
                this.devices = [];
                this.device = {id: '', label: 'Terminal'};
                this.arrayFilter.device = '';
                axios.get('/api/repositories/device')
                    .then(result => {
                        let arrayDevice = _.orderBy(result.data.data, 'single_key', 'asc');
                        _.forEach(arrayDevice, value => {
                            this.devices.push(
                                {
                                    id: value.id,
                                    imei: value.imei,
                                    label: value.single_key.toString(),
                                }
                            );
                        })
                    })
            },

            getTigreExportStatus() {
                this.tigreExportStatus = {id: '', label: 'Status export Tigre', value: ''};
                this.tigreExportStatuses = [
                    {id: 1, label: 'Non soumis', value: 'null'},
                    {id: 2, label: 'Ignoré', value: -1},
                    {id: 3, label: 'En erreur', value: 0},
                    {id: 4, label: 'Soumis', value: 1}
                ];
                this.arrayFilter.tigreExportStatus = '';
            },

            initData() {
                this.arrayFilter.date = '';
                this.dateStart = moment().subtract(this.dateDefine - 1, 'd').format('YYYY-MM-DD');
                this.dateEnd = moment().format('YYYY-MM-DD');
                this.$refs.datePickerComponent.range = {
                    startDate: new Date(moment().subtract(this.dateDefine - 2, 'd').format('YYYY-MM-DD')),
                    endDate: new Date(moment().add(1, 'd').format('YYYY-MM-DD'))
                };
            },

            getUrlParam() {
                this.urlParam = '?line=' + this.line.id +
                    "&officer=" + this.officer.id +
                    "&vehicle=" + this.vehicle.id +
                    "&reason=" + this.reason.id +
                    "&device=" + this.device.imei +
                    "&start=" + this.dateStart +
                    "&end=" + this.dateEnd +
                    "&session=" + this.idSession +
                    "&exported=" + this.tigreExportStatus.value;
            },

            initFilter() {
                this.getLine();
                this.getVehicle();
                this.getOfficer();
                this.getReason();
                this.getDevice();
                this.initData();
                this.getUrlParam();
                this.getTigreExportStatus();
                this.filter();
            },

            deleteFilter(index) {
                this.arrayFilter[index] = '';

                switch (index) {
                    case 'officer':
                        this.officer = {id: '', label: 'Agent'};
                        this.arrayFilter.officer = '';
                        break;
                    case 'vehicle':
                        this.vehicle = {id: '', label: 'Vehicule'};
                        this.arrayFilter.vehicle = '';
                        break;
                    case 'line':
                        this.line = {id: '', label: 'Ligne'};
                        this.arrayFilter.line = '';
                        break;
                    case 'reason':
                        this.reason = {id: '', label: 'Raison'};
                        this.arrayFilter.reason = '';
                        break;
                    case 'device':
                        this.device = {id: '', value: '', label: 'Terminal'};
                        this.arrayFilter.device = '';
                        break;
                    case 'date':
                        this.dateStart = moment().subtract(this.dateDefine - 1, 'd').format('YYYY-MM-DD');
                        this.dateEnd = moment().format('YYYY-MM-DD');
                        this.$refs.datePickerComponent.range = {
                            startDate: new Date(moment().subtract(this.dateDefine - 2, 'd').format('YYYY-MM-DD')),
                            endDate: new Date(moment().add(1, 'd').format('YYYY-MM-DD'))
                        };
                        break;
                    case 'tigreExportStatus':
                        this.tigreExportStatus = {id: '', label: 'Status export Tigre', value: ''};
                        this.arrayFilter.tigreExportStatus = '';
                        break;
                }
            },

            filter() {
                this.isActiveChart = true;
                this.getUrlParam();
                this.updateVueTable();
                this.updateGraphic();
                this.updateMap();
            },

            updateGraphic() {
                axios.get('/api/fines/graph' + this.urlParam)
                    .then(result => {
                        let dataChart = {
                            labels: [],
                            datasets: [
                                {
                                    label: 'Nombre de pv',
                                    backgroundColor: "rgba(196, 93, 105, 0.3)",
                                    data: []
                                }
                            ]
                        };
                        _.forEach(result.data, value => {
                            if (this.dateStart === this.dateEnd) {
                                dataChart.labels.push(value.name); //moment(value.name.date).format('HH') + 'h');
                                dataChart.datasets[0].data.push(value.value);
                            } else {
                                dataChart.labels.push(value.name); //moment(value.name.date).format('DD/MM/YYYY'));
                                dataChart.datasets[0].data.push(value.value);
                            }
                        });
                        this.dataChart = dataChart;
                        this.isActiveChart = false;
                    })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            updateVueTable() {
                this.moreParams = {
                    'line': this.line.id,
                    'officer': this.officer.id,
                    'vehicle': this.vehicle.id,
                    'reason': this.reason.id,
                    'device': this.device.imei,
                    'start': this.dateStart,
                    'end': this.dateEnd,
                    'session': this.idSession,
                    'exported': this.tigreExportStatus.value
                };
                Vue.nextTick(() => this.$refs.vuetable.refresh());
            },

            updateMap() {
                axios.get('/api/fines/map' + this.urlParam)
                    .then(result => {
                        this.arrayMarkers = [];

                        _.forEach(result.data[0], value => {
                            this.arrayMarkers.push(value);
                        });
                    })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            getDate(start, end, date) {
                this.arrayFilter.date = {id: 1, label: date};
                this.dateStart = start;
                this.dateEnd = end;
            },

            openDetailsModal(fineId) {
                this.fineId = fineId;
                this.showDetailsModal = true;
            },

            closeDetailsModal() {
                this.showDetailsModal = false;
            },

            openExportModal(fineId = null) {
                this.fineId = fineId;
                this.showExportModal = true;
            },

            closeExportModal() {
                this.showExportModal = false;
            },

            openExportResultModal() {
                this.showExportResultModal = true;
            },

            closeExportResultModal() {
                this.showExportResultModal = false;
            },

            openHtmlModal(fineCode) {
                this.fineCode = fineCode;
                this.showHtmlModal = true;
            },

            closeHtmlModal() {
                this.showHtmlModal = false;
            },

            deselectAll() {
                this.fineIdsToExport = [];
            },

            selectAll() {
                var selected = [];
                this.$refs.vuetable.tableData.forEach(function (user) {
                    selected.push(user.id);
                });
                this.fineIdsToExport = selected;
            },

            exportToTigre() {
                this.exportInProgress = true;
                axios.post('/api/export/fines', {ids: this.fineIdsToExport})
                    .then(result => {
                        const nbPv = this.fineIdsToExport.length;
                        const nbPvInError = result.data.length;
                        const nbPvInSuccess = nbPv - nbPvInError;
                        this.exportResult = nbPvInSuccess + ' PV sur ' + nbPv + ' exporté(s) avec succès';
                        this.fineExportsInError = result.data;
                        this.fineIdsToExport = [];
                        this.exportInProgress = false;
                        this.showExportResultModal = true;
                        this.$refs.vuetable.refresh()
                    })
                    .catch((error) => {
                        this.exportResult = 'Une erreur est survenue';
                        this.fineExportsInError = [];
                        this.exportInProgress = false;
                        this.showExportResultModal = true;
                    });
            },

            getGlobalExportStatus(exportedValue, exportedImageValue) {
                if (exportedValue === null && exportedImageValue === null) {
                    return 'Non soumis';
                } else if (exportedValue === 0 || exportedImageValue === 0) {
                    return 'En erreur';
                } else if (exportedValue === 1 || exportedImageValue === 1) {
                    return 'Soumis';
                } else if (exportedValue === -1 || exportedImageValue === -1) {
                    return 'Ignoré';
                }
            },

            deleteSession() {
                this.idSession = '';
                this.filter();
            },
        }
    }
</script>

<style>

    .customLoader {
        z-index: 0 !important;
    }

    .action-container {
        white-space: nowrap;
    }

</style>



// WEBPACK FOOTER //
// resources/js/components/Fine.vue